<div class="a-titulo">
    MANTENIMIENTO PROVEEDORES
</div>
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-row">
        <div class="a-w1 a-w1-row">
            <p-floatlabel variant="on" class="a-w6">
                <input formControlName="numdocumento" pInputText type="text" class="w-full" />
                <label for="float-label">Número Documento</label>
            </p-floatlabel>
            <p-floatlabel variant="on" class="a-w4">
                <input formControlName="razonsocial" pInputText type="text" class="w-full" />
                <label for="razonSocial">Razon Social</label>
            </p-floatlabel>
            <div style="display: flex; gap: 20px;">
                <p-button icon="pi pi-search" label="Buscar" variant="outlined" (onClick)="search()"
                    type="button"></p-button>
                <p-button icon="pi pi-plus" label="Nuevo" variant="outlined" (onClick)="nuevo()"></p-button>
                <p-button icon="pi pi-file-excel" label="Exportar" variant="outlined"
                    (onClick)="exportExcel()"></p-button>
                <p-button icon="pi pi-sign-out" label="Salir" variant="outlined"
                    (onClick)="salirBandejaPrincipal()"></p-button>
            </div>
        </div>
    </form>
</div>
<app-datatable [metadataTable]="metadataTable" [dataTable]="dataTable" [filterGlobal]="true">
    <ng-template #addHeaderStart>
        <th class="header">
            <div class="items-header">
                <span>Acción</span>
            </div>
        </th>
    </ng-template>
    <ng-template #addBodyStart let-row="row">
        <td class="a-datatable-datos-body-accion row-space">
            <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="editProveedor('',row)" pTooltip="Editar" tooltipPosition="top"></p-button>
            <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-outlined"
                (onClick)="eliminar(row)" pTooltip="Eliminar" tooltipPosition="top"></p-button>
        </td>
    </ng-template>
</app-datatable>

<div class="footer"></div>

<p-dialog [(visible)]="visible" [style]="{width: '60vw',height: '100vh'}" appendTo="body" [maximizable]="true"
    modal="true" draggable="false" closeOnEscape="false">
    <div style="justify-content: center; display: flex; gap: 20px;">
        <p-button icon="pi pi-save" label="Guardar" variant="outlined" *ngIf="visiblebtn"
            (onClick)="TransaccionEntidad('I', 0)"></p-button>
        <p-button icon="pi pi-history" label="Actualizar" variant="outlined" *ngIf="!visiblebtn"
            (onClick)="TransaccionEntidad('U', 0)"></p-button>
        <p-button icon="pi pi-sign-out" label="Salir" variant="outlined" (onClick)="salir($event)"></p-button>
    </div>

    <p-tabView>
        <p-toast key="toast3"></p-toast>
        <p-tabPanel header="Datos Generales">
            <form [formGroup]="groupPoppupDG" class="a-w1-column">
                <div class="a-w1-row" *ngIf="prueba">
                    <p-floatlabel variant="on" class="a-w2">
                        <input formControlName="codigo" type="text" pInputText [readOnly]="true" class="w-full" />
                        <label for="float-label">Código</label>
                    </p-floatlabel>
                    <div class="a-w2 activo-centrado">
                        <!-- <div class="flex align-items-center gap-1 a-w1"> -->
                        <p-checkbox formControlName="activo" [binary]="true" inputId="binary"></p-checkbox>
                        <label for="activo">Activo</label>
                        <!-- </div> -->
                    </div>
                </div>
                <div class="a-w1-row">
                    <div class="a-w1">
                        <span class="radiobtn-center">
                            <div *ngFor="let t of tipo" class="field-checkbox">
                                <p-radioButton [inputId]="t.key" [value]="t.key" formControlName="tipopersona"
                                    (ngModelChange)="verInputs($event)"></p-radioButton>
                                <label [for]="t.key" class="ml-2">{{ t.name }}</label>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="a-w1-row">

                    <p-floatlabel variant="on" class="a-w3" *ngIf="ListaTodosTipoDoc && ListaTodosTipoDoc.length > 0">
                        <p-select [options]="ListaTodosTipoDoc" optionLabel="label" formControlName="tipodocumento"
                            optionValue="value" appendTo="body" styleClass="w-full" id="float-label"
                            (onChange)="onChangeTipoDocumento('EVE',$event)">
                            <label for="float-label">Tipo Documento</label>
                        </p-select>
                    </p-floatlabel>

                    <div class="a-w3" *ngIf="visiblenumdoc">
                        <p-inputgroup>
                            <p-floatlabel variant="on">
                                <input formControlName="numerodocumento" pInputText type="text" class="w-full" />
                                <label for="float-label">Número Documento</label>
                            </p-floatlabel>
                            <p-toast key="toast1"></p-toast>
                            <p-toast key="toast2"></p-toast>
                            <button type="button" pButton pRipple icon="pi pi-search" (click)="validarDocumento()"
                                styleClass="p-button-info"></button>
                        </p-inputgroup>
                    </div>
                    <div class="a-w3" *ngIf="juridica">
                        <p-floatlabel variant="on">
                            <input formControlName="razoncomercial" pInputText type="text" class="w-full" />
                            <label for="float-label">Razón Comercial</label>
                        </p-floatlabel>
                    </div>
                </div>

                <div class="a-w1-row" *ngIf="juridica">
                    <p-floatlabel variant="on" class="a-w1">
                        <input formControlName="razonsocial" pInputText type="text" class="w-full" />
                        <label for="float-label">Razón Social</label>
                    </p-floatlabel>

                </div>

                <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
                    <p-floatlabel variant="in" class="a-w1">
                        <input formControlName="nomgerente" pInputText type="text" class="w-full h-3rem" />
                        <label for="float-label">Nombre Gerente</label>
                    </p-floatlabel>
                </div>
                <div class="a-w1-row" style="padding-top: 20px;" *ngIf="juridica">
                    <div class="a-w2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechanacimientog" appendTo="body" [showIcon]="true"
                                styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [maxDate]="fechaActual">
                            </p-datepicker>
                            <label for="on_label">Fecha Nacimiento</label>
                        </p-floatLabel>
                    </div>
                    <div class="a-w2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechaAniversariog" appendTo="body" [showIcon]="true"
                                styleClass="w-full md:w-56" dateFormat="dd/mm/yy">
                            </p-datepicker>
                            <label for="float-label">Fecha Aniversario</label>
                        </p-floatLabel>
                    </div>
                </div>
                <div class="a-w1-row" *ngIf="natural">
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <p-floatlabel variant="on" class="a-w1">
                            <input formControlName="apellidopaterno" pInputText type="text" class="w-full h-3rem" />
                            <label for="float-label">Apellido Paterno</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <p-floatlabel variant="on" class="a-w1">
                            <input formControlName="apellidomaterno" pInputText type="text" class="w-full h-3rem" />
                            <label for="float-label">Apellido Materno</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <p-floatlabel variant="on" class="a-w1">
                            <input formControlName="nombres" pInputText type="text" class="w-full h-3rem" />
                            <label for="float-label">Nombres</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-w2">
                        <span class="radiobtn-center">
                            <div *ngFor="let s of sexo" class="field-checkbox">
                                <p-radioButton [inputId]="s.key" [value]="s.key" formControlName="sexo"></p-radioButton>
                                <label [for]="s.key" class="ml-2">{{ s.name }}</label>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <p-floatlabel variant="on" class="a-w1">
                            <input formControlName="area" pInputText type="text" class="w-full h-3rem" />
                            <label for="float-label">Área</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <p-floatlabel variant="on" class="a-w1">
                            <input formControlName="cargo" pInputText type="text" class="w-full h-3rem" />
                            <label for="float-label">Cargo</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
                    <div class="a-w2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechanacimiento" appendTo="body" [showIcon]="true"
                                styleClass="w-full md:w-56" dateFormat="dd/mm/yy" [maxDate]="fechaActual">
                            </p-datepicker>
                            <label for="on_label">Fecha Nacimiento</label>
                        </p-floatLabel>
                    </div>
                    <div class="a-w2">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <p-datepicker formControlName="fechaingreso" appendTo="body" [showIcon]="true"
                                styleClass="w-full md:w-56" dateFormat="dd/mm/yy">
                            </p-datepicker>
                            <label for="on_label">Fecha Ingreso</label>
                        </p-floatLabel>
                    </div>
                </div>
                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w1">
                        <input formControlName="correo" pInputText type="text" class="w-full" />
                        <label for="float-label">Correo</label>
                    </p-floatlabel>
                </div>
                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w1">
                        <input formControlName="correo" pInputText type="text" class="w-full" />
                        <label for="float-label">Correo Adicional</label>
                    </p-floatlabel>
                </div>
                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w2">
                        <input formControlName="contactonombre" pInputText type="text" class="w-full" />
                        <label for="float-label">Contacto Nombre</label>
                    </p-floatlabel>
                    <p-floatlabel variant="on" class="a-w2">
                        <input formControlName="contactoapellidos" pInputText type="text" class="w-full" />
                        <label for="float-label">Apellidos</label>
                    </p-floatlabel>
                </div>
                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w1">
                        <input formControlName="direccion" pInputText type="text" class="w-full" />
                        <label for="float-label">Dirección</label>
                    </p-floatlabel>
                </div>

                <div class="a-w1-row">
                    <p-floatLabel class="a-w2" variant="on" *ngIf="listPais && listPais.length > 0">
                        <p-select [options]="listPais" optionLabel="label" formControlName="pais" optionValue="value"
                            appendTo="body" [filter]="true" class="w-full"
                            (onChange)="onPaisSeleccionado($event,'EVE')">
                        </p-select>
                        <label for="on_label">País</label>
                    </p-floatLabel>
                    <p-floatLabel class="a-w2" variant="on">
                        <p-select [options]="listDepartamento" placeholder="‎ " optionLabel="ubiG_Desc"
                            formControlName="departamento" appendTo="body" [filter]="true" class="w-full"
                            optionValue="ubiG_Codigo" (onChange)="onDepartamentoSeleccionado($event,'EVE')">
                        </p-select>
                        <label for="on_label">Departamento</label>
                    </p-floatLabel>
                </div>
                <div class="a-w1-row" style="padding-top: 20px;">
                    <div class="a-w2">

                        <p-floatlabel variant="in">
                            <p-select [options]="listProvincia" appendTo="body" formControlName="provincia"
                                optionLabel="ubiG_Desc" optionValue="ubiG_Codigo" styleClass="w-full h-3rem text-xs"
                                [filter]="true" [showClear]="true" [filter]="true"
                                (onChange)="onprovinciaSeleccionada($event, 'EVE')" />
                            <label for="provincia">Provincia</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-w2">

                        <p-floatlabel variant="in">
                            <p-select [options]="listDistrito" appendTo="body" optionLabel="ubiG_Desc"
                                formControlName="distrito" optionValue="ubiG_Codigo" styleClass="w-full h-3rem text-xs"
                                [filter]="true" [showClear]="true" [filter]="true" />
                            <label for="distrito">Distrito</label>
                        </p-floatlabel>
                    </div>
                </div>

                <div class="a-w1-row">
                    <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">

                        <div style="display: flex; flex-direction: column; gap: 20px; justify-content: center;">
                            <div class="flex align-items-center gap-1">
                                <span class="p-float-label">
                                    <p-checkbox formControlName="nodomiciliado" [binary]="true"
                                        inputId="binary"></p-checkbox>
                                    <label style="padding-left: 20px;">No Domiciliado</label>
                                </span>
                            </div>
                            <div class="flex align-items-center gap-1">
                                <span class="p-float-label">
                                    <p-checkbox formControlName="cobrodf" [binary]="true" inputId="binary"></p-checkbox>
                                    <label style="padding-left: 20px;">Cobro por domingo o feriado</label>
                                </span>
                            </div>
                            <div class="flex align-items-center gap-1">
                                <span class="p-float-label">
                                    <p-checkbox formControlName="cobrofh" [binary]="true" inputId="binary"></p-checkbox>
                                    <label style="padding-left: 20px;">Cobro fuera de horario</label>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="a-w2 a-w1-column">

                        <p-floatlabel variant="on" class="w-full md:w-56">
                            <p-inputNumber inputId="minmax-buttons" [showButtons]="true" [min]="0"
                                formControlName="diascreditos"></p-inputNumber>
                            <label for="on_label">Días Créditos</label>
                        </p-floatlabel>
                        <p-floatlabel variant="on" class="w-full md:w-56">
                            <p-inputNumber inputId="minmax-buttons" [showButtons]="true" [min]="0"
                                formControlName="cobrodfporcentaje"></p-inputNumber>
                            <label for="on_label">% Cobro</label>
                        </p-floatlabel>
                        <p-floatlabel variant="on" class="w-full md:w-56">
                            <p-inputNumber inputId="minmax-buttons" [showButtons]="true" [min]="0"
                                formControlName="cobrofhporcentaje"></p-inputNumber>
                            <label for="on_label">% Cobro</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-w1-row">

                    <p-floatlabel variant="on" class="a-w1">
                        <textarea pTextarea class="a-w1"></textarea>
                        <label for="float-label">Observaciones</label>
                    </p-floatlabel>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel header="Datos Financieros">
            <p-toast key="toast1"></p-toast>
            <p-toast key="toast2"></p-toast>
            <p-accordion [activeIndex]="activeIndex" [multiple]="true">
                <p-accordionTab header="Cuentas Bancarias">
                    <!-- <p-button label="VerData" (onClick)="verDatos($event)"></p-button> -->
                    <app-datatable [metadataTable]="metadataTableCuentasBancarias" [rowDelete]="true"
                        [dataTable]="dataTableCuentasBancarias" [addRow]="true" [rowEdit]="true" [key]="'key'"
                        [defaultRow]="defaultRowCuentasBancarias">
                    </app-datatable>
                </p-accordionTab>
                <p-accordionTab header="Datos">
                    <br>
                    <form [formGroup]="groupPoppupD" class="a-w1" style="margin: 0;">
                        <div class="a-w1-row">
                            <div class="a-w2">

                                <p-floatlabel variant="on">
                                    <input formControlName="correofinanzas" pInputText type="text" class="w-full" />
                                    <label for="float-label">Correo de Finanzas</label>
                                </p-floatlabel>
                            </div>
                        </div>
                        <div class="a-w1-row" style="padding-top: 20px;">
                            <div class="a-w2">
                                <p-floatlabel variant="on">
                                    <input formControlName="ctaintersoles" type="text" pInputText />
                                    <label for="float-label">Cta. Interbancaria Soles</label>
                                </p-floatlabel>
                            </div>

                            <div class="a-w2">
                                <p-floatlabel variant="on">
                                    <input formControlName="ctainterdolares" type="text" pInputText />
                                    <label for="float-label">Cta. Interbancaria Dólares</label>
                                </p-floatlabel>
                            </div>
                        </div>
                        <div class="a-w1-row" style="padding-top: 20px;">

                            <div class="a-w2">
                                <p-floatlabel variant="on">
                                    <input formControlName="ctadetracciones" type="text" pInputText />
                                    <label for="float-label">Cta. Interbancaria Detracciones</label>
                                </p-floatlabel>
                            </div>
                            <div class="a-w2">
                                <span class="p-float-label" class="activo-centrado" style="justify-items: center;">
                                    <div class="flex align-items-center gap-1">
                                        <p-checkbox formControlName="asumedetraccion" [binary]="true"
                                            inputId="binary"></p-checkbox>
                                        <label for="activo">Proveedor Asume Detracción</label>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </form>
                </p-accordionTab>
                <p-accordionTab header="Límite de Crédito">
                    <app-datatable [metadataTable]="metadataTableLimiteCredito" [dataTable]="dataTableLimiteCredito"
                        [addRow]="true" [rowEdit]="true" [key]="'key'">
                        <ng-template #addHeaderEnd>
                            <th class="header">
                            </th>
                        </ng-template>
                        <ng-template #addBodyEnd let-row="row">
                            <td class="a-datatable-datos-body-accion row-space">
                                <p-button icon="pi pi-history"
                                    styleClass="p-button-rounded p-button-warning p-button-outlined"
                                    (onClick)="op.toggle($event)" pTooltip="Ver Historial"
                                    tooltipPosition="top"></p-button>
                            </td>
                            <p-overlayPanel #op [style]="{'width': '630px'}" (onShow)="verHistorial('',row)">
                                <ng-template pTemplate="content">
                                    <app-datatable [metadataTable]="metadataTableHistorial"
                                        [dataTable]="dataTableHistorial">
                                    </app-datatable>
                                </ng-template>
                            </p-overlayPanel>
                        </ng-template>
                    </app-datatable>
                </p-accordionTab>

                <p-accordionTab header="Bloqueo">
                    <form [formGroup]="groupPoppupB" class="a-w1" style="margin: 0;">

                        <div class="a-w1-row" style="padding-top: 20px;">
                            <div class="a-w3">
                                <p-float-label variant="on">
                                    <input formControlName="usuariobloqueo" type="text" pInputText />
                                    <label for="float-label">Usuario</label>
                                </p-float-label>
                            </div>
                            <div class="a-w3">

                                <p-floatlabel variant="on">
                                    <p-datepicker formControlName="fechabloqueoo" appendTo="body" [showIcon]="true"
                                        class="p-inputtext-sm" dateFormat="dd/mm/yy" styleClass="w-full"
                                        inputStyleClass="w-full">
                                    </p-datepicker>
                                    <label for="float-label">Fecha Bloqueo</label>
                                </p-floatlabel>
                            </div>
                            <div class="a-w6-row ml-4">
                                <span class="p-float-label" class="activo-centrado">
                                    <div class="flex align-items-center gap-1">
                                        <p-checkbox formControlName="bloqueado" [binary]="true" inputId="binary"
                                            (ngModelChange)="cargarInputBloqueo($event)"></p-checkbox>
                                        <label for="activo">Bloqueado</label>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div class="a-w1-row" style="padding-top: 20px;">


                            <p-floatlabel variant="on" class="a-w1">
                                <textarea pTextarea class="a-w1"></textarea>
                                <label for="float-label">Comentarios</label>
                            </p-floatlabel>
                        </div>
                    </form>
                </p-accordionTab>
                <p-accordionTab header="Archivos">
                    <div>
                        <p-fileUpload chooseLabel="Seleccionar Archivo" name="demo[]" [multiple]="true"
                            url="https://www.primefaces.org/cdn/api/upload.php" [style]="{'width': '100%'}"
                            accept="image/*,.xls,.xlsx,.pdf.docx,.txt,.doc" [maxFileSize]="1000000"
                            (onSelect)="onUpload($event)" [auto]="true">
                            <ng-template pTemplate="content" style="display: none;"></ng-template>
                        </p-fileUpload>
                        <!-- <p-button label="Guardar" icon="pi pi-save" (onClick)="onUpload($event)"></p-button> -->
                        <div style="padding-top: 10px;">
                            <p-table [value]="uploadedFiles"
                                [tableStyle]="{'width': '100%','font-size': '13px', 'padding': '2px'}">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th style="width:5%">Descargar</th>
                                        <th style="width:5%">Eliminar</th>
                                        <th style="width:17%">Tipo Doc.</th>
                                        <th style="width:18%">Usuario Crea</th>
                                        <th style="width:17%">Fecha Crea</th>
                                        <th style="width:36%">Nombre</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-row let-columns="columns">
                                    <tr *ngIf="row.tipotran != 'D'">
                                        <td><p-button class="btnsmall" icon="pi pi-download"
                                                styleClass="p-button-rounded p-button-outlined p-button-sm"
                                                (onClick)="downloadArchivo('',row)"></p-button></td>
                                        <td><p-button icon="pi pi-trash"
                                                styleClass="p-button-rounded p-button-danger p-button-outlined p-button-sm"
                                                (onClick)="deleteArchivo(row)"></p-button></td>
                                        <td><img [src]="obtenerIconoTipoArchivo(row.nombre)"
                                                style="width: 35px; height: 35px; margin-right: 10px;"></td>
                                        <td>{{row.usuario}}</td>
                                        <td>{{row.fecha}}</td>
                                        <td>{{row.nombre}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </p-tabPanel>
        <p-tabPanel header="Auditoría">
            <p-toast key="toast1"></p-toast>
            <p-toast key="toast2"></p-toast>
            <app-datatable [metadataTable]="metadataTableAuditoria" [dataTable]="dataTableAuditoria"
                [customButtons]="dataButtons">
            </app-datatable>
        </p-tabPanel>
        <p-tabPanel header="Paquete Servicio" *ngIf="prueba">
            <p-toast key="toast1"></p-toast>
            <p-toast key="toast2"></p-toast>
            <form [formGroup]="groupPS" class="a-w1" style="margin: 0;">
                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w3">
                        <p-select [options]="listReg" appendTo="body" formControlName="regimen" styleClass="w-full"
                            (onChange)="filtrarServicio()" [filter]="true" [showClear]="true" size="small" />
                        <label for="regimen">Regimen</label>
                    </p-floatlabel>

                    <p-floatlabel variant="on" class="a-w3">
                        <p-select [options]="lineaNegocio" appendTo="body" formControlName="lineanegocio"
                            styleClass="w-full" (onChange)="filtrarServicio()" [filter]="true" [showClear]="true"
                            size="small" />
                        <label for="lineanegocio">Linea De Negocio</label>
                    </p-floatlabel>

                    <p-floatlabel variant="on" class="a-w4">
                        <p-select [options]="listVia" appendTo="body" formControlName="via" styleClass="w-full"
                            [showClear]="true" (onChange)="filtrarServicio()" size="small" />
                        <label for="lineanegocio">Via</label>
                    </p-floatlabel>
                </div>


                <div class="a-w1-row">
                    <p-floatlabel variant="on" class="a-w2">

                        <p-multi-select [options]="listaServicios" appendTo="body" formControlName="servicios"
                            styleClass="w-full" [filter]="true" [showClear]="true" size="small" optionLabel="nombre" />
                        <label for="servicios">Servicios</label>
                    </p-floatlabel>
                    <div style="justify-content: center; display: flex; gap: 20px;">
                        <p-button icon="pi pi-plus" label="Agregar" size="small" variant="outlined"
                            (onClick)="agregarServicio()"></p-button>
                    </div>
                </div>
            </form>
            <app-datatable [metadataTable]="mdtS" [dataTable]="dtS" [key]="'key'">
                <ng-template #addHeaderStart>
                    <th class="header">
                        <div class="items-header">
                            <span>Acción</span>
                        </div>
                    </th>
                </ng-template>

                <ng-template #addBodyStart let-row="row">
                    <td class="a-datatable-datos-body-accion row-space">
                        <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-outlined"
                            (onClick)="deleteServicio(row)" pTooltip="Eliminar" tooltipPosition="top">
                        </p-button>
                    </td>
                </ng-template>
            </app-datatable>
        </p-tabPanel>
        <p-tabPanel header="Otros Datos">
            <!-- <form [formGroup]="groupOD" class="a-w1" style="margin: 0;"> -->
            <p-toast key="toast1"></p-toast>
            <p-toast key="toast2"></p-toast>
            <p-accordion [activeIndex]="activeIndex" [multiple]="true">
                <p-accordionTab header="Zona Transporte">
                    <form [formGroup]="groupOD" class="a-w1" style="margin: 0;">
                        <div class="a-w1-row" style="padding-top: 20px;">
                            <div class="a-w3">
                                <p-floatlabel variant="on">
                                    <p-select [options]="listDepartamento" appendTo="body"
                                        formControlName="departamento" optionLabel="ubiG_Desc" styleClass="w-full"
                                        size="small" [showClear]="true" [filter]="true"
                                        (onChange)="onDepartamentoOSeleccionado($event,null)" />
                                    <label for="departamento">Departamento</label>
                                </p-floatlabel>
                            </div>
                            <div class="a-w3">
                                <p-floatlabel variant="on">
                                    <p-select [options]="listProvinciaO" appendTo="body" formControlName="provincia"
                                        optionLabel="ubiG_Desc" styleClass="w-full" size="small" [filter]="true"
                                        [showClear]="true" [filter]="true"
                                        (onChange)="onProvinciaOSeleccionado($event,null)" />
                                    <label for="provincia">Provincia</label>
                                </p-floatlabel>
                            </div>
                            <p-floatLabel class="a-w3" variant="on">
                                <p-select [options]="listDistritoO" optionLabel="ubiG_Desc" formControlName="distrito"
                                    size="small" appendTo="body" class="w-full" [filter]="true" [showClear]="true">
                                </p-select>
                                <label for="on_label">Distrito</label>
                            </p-floatLabel>
                        </div>
                        <br>
                        <div class="a-w2">

                            <span class="p-float-label">
                                <p-button icon="pi pi-plus" label="Agregar"
                                    (onClick)="agregarZonatransporte()"></p-button>
                            </span>
                        </div>
                    </form>
                    <br>
                    <div class="a-w1-row" style="padding-top: 20px;">
                        <div class="a-w1-column">
                            <app-datatable [metadataTable]="metadataTableZonaTransporte"
                                [dataTable]="TableZonaTransporte" [key]="'key'">
                                <ng-template #addHeaderStart>
                                    <th class="header">
                                        <div class="items-header">
                                            <span>Acción</span>
                                        </div>
                                    </th>
                                </ng-template>

                                <ng-template #addBodyStart let-row="row">
                                    <td class="a-datatable-datos-body-accion row-space">
                                        <p-button icon="pi pi-trash"
                                            styleClass="p-button-rounded p-button-danger p-button-outlined"
                                            (onClick)="deleteTransporte(row)" pTooltip="Eliminar" tooltipPosition="top">
                                        </p-button>
                                    </td>
                                </ng-template>
                            </app-datatable>
                        </div>
                    </div>


                </p-accordionTab>
                <p-accordionTab header="Tipo Carga">
                    <form [formGroup]="groupTC" class="a-w1" style="margin: 0;">
                        <div class="a-w1-row" style="padding-top: 20px;">
                            <div class="a-w2" *ngIf="listaTodosCarga && listaTodosCarga.length > 0">
                                <p-floatlabel variant="on">
                                    <p-select [options]="listaTodosCarga" appendTo="body" formControlName="tipocarga"
                                        optionLabel="label" styleClass="w-full" size="small" [filter]="true"
                                        [showClear]="true" />
                                    <label for="tipocarga">Tipo Carga</label>
                                </p-floatlabel>
                                <br>
                            </div>

                            <div class="a-w2">
                                <span class="p-float-label">
                                    <p-button icon="pi pi-plus" label="Agregar"
                                        (onClick)="agregarTipoCarga()"></p-button>
                                </span>
                            </div>
                        </div>
                    </form>
                    <div class="a-w1-column">
                        <app-datatable [metadataTable]="metadataTableZonaTipoCarga" [dataTable]="dtT" [key]="'key'">
                            <ng-template #addHeaderStart>
                                <th class="header">
                                    <div class="items-header">
                                        <span>Acción</span>
                                    </div>
                                </th>
                            </ng-template>

                            <ng-template #addBodyStart let-row="row">
                                <td class="a-datatable-datos-body-accion row-space">
                                    <p-button icon="pi pi-trash"
                                        styleClass="p-button-rounded p-button-danger p-button-outlined"
                                        (onClick)="deleteRow(row)" pTooltip="Eliminar" tooltipPosition="top">
                                    </p-button>
                                </td>
                            </ng-template>
                        </app-datatable>
                    </div>
                </p-accordionTab>
            </p-accordion>
            <!-- </form> -->

        </p-tabPanel>
    </p-tabView>
</p-dialog>